module.exports = __webpack_public_path__ + "static/media/arrow-up.7e1ea4a4.svg";